module.exports = __webpack_public_path__ + "assets/img/detail-btn-9ce7567f.png";